module.exports = __webpack_public_path__ + "static/media/download-big-icon.11496e3d.svg";